import { getGraphURL } from "../serviceHelper";
import { Page, RequestType } from "../../constants";
import { DateHelper, StringHelper } from "../../helper";
import pick from "lodash/pick";
import { GraphRequestBaseService } from "../GraphRequestBase.service";

const fields = [
  "Title",
  "eRequestStatus",
  "eRequestType",
  "eContent",
  "eDepartmentCode",
  "eApprovalProcess",
  "eComments",
];

const BASE_URL = getGraphURL(Page.monthlyTrainingPlanSummary);

export class HOMonthlyTrainingPlanSummaryService extends GraphRequestBaseService {
  constructor(public baseURL: string, fields: string[]) {
    super(baseURL, fields);
  }

  toRequest(values: any = {}) {
    const request = pick(values, fields);

    if (values?.eApprovalProcess) {
      request["eApprovalProcess"] = JSON.stringify(values.eApprovalProcess);
    }
    return {
      ...request,
      Title: "Bảng tổng hợp kế hoạch đào tạo tháng",
      eRequestType: RequestType.confirm,
    };
  }
  toResponse(response: any = {}) {
    const eCreatedBy = `${response.createdBy.user.email}|${response.createdBy.user.displayName}`;
    const eContent = JSON.parse(response.fields.eContent);
    const mappedEContent = eContent.map((item: any) => {
      const { eTrainingCourses = [] } = item;
      const mappedETrainingCourses = eTrainingCourses.map((e: any) => {
        const { eDateTime = [] } = e;
        const mappedEDatetime = eDateTime.map((datetime: string) =>
          DateHelper.formatDateToMoment(datetime)
        );
        return { ...e, eDateTime: mappedEDatetime };
      });
      return { ...item, eTrainingCourses: mappedETrainingCourses };
    });

    return {
      ...response.fields,
      id: response.id,
      eCreatedBy,
      createdDateTime: response.createdDateTime,
      eContent: mappedEContent,
      eComments: StringHelper.parseJSON(response?.fields?.eComments, []),
      eApprovalProcess: JSON.parse(response.fields.eApprovalProcess),
    };
  }
}

export const monthlyTrainingPlanSummaryApi =
  new HOMonthlyTrainingPlanSummaryService(BASE_URL, fields);
